import { getClosestViewport } from '../utils';
export function isNumberKey(event) {
  return event.keyCode >= 48 && event.keyCode <= 57;
}
export function isLetterKey(event) {
  return event.keyCode >= 65 && event.keyCode <= 90;
}
export function isSpecialKey(event) {
  return event.keyCode >= 188 && event.keyCode <= 190;
}
export function isComboKey(event) {
  return event.ctrlKey || event.metaKey || event.altKey;
}
export function modulo(val, max) {
  return val >= 0 ? val % max : (val % max + max) % max;
}
export function scroller(node) {
  if (node === document.body) {
    return {
      offsetTop: 0,
      scrollY: window.pageYOffset,
      height: window.innerHeight,
      setPosition: function setPosition(top) {
        return window.scrollTo(0, top);
      }
    };
  } else {
    return {
      offsetTop: node.getBoundingClientRect().top,
      scrollY: node.scrollTop,
      height: node.offsetHeight,
      setPosition: function setPosition(top) {
        return node.scrollTop = top;
      }
    };
  }
}
export function scrollIntoView(node) {
  var scrollParent = scroller(getClosestViewport(node));

  if (scrollParent === null) {
    return;
  }

  var nodeRect = node.getBoundingClientRect();
  var nodeTop = scrollParent.scrollY + (nodeRect.top - scrollParent.offsetTop);

  if (nodeTop < scrollParent.scrollY) {
    // the item is above the scrollable area
    scrollParent.setPosition(nodeTop);
  } else if (nodeTop + nodeRect.height > scrollParent.scrollY + scrollParent.height) {
    // the item is below the scrollable area
    scrollParent.setPosition(nodeTop + nodeRect.height - scrollParent.height);
  }
}